import {getStore} from "trim-redux";
import {FA} from "./fa";
import i18n from "i18next";

export function translate(string, lang = "") {
    if (lang === "") {
        lang = getStore('locale');
    }
    if (lang === "fa") {
        return FA[string] ?? string;
    }
    const fromI18n = i18n.t(string);
    if (fromI18n && fromI18n !== string) {
        return fromI18n;
    }
    return typeof fromI18n === "string" ? fromI18n : string;
}

